<template>
  <v-autocomplete
    :items="chargeTypesList"
    v-model="selectedCharge"
    :label="label"
    item-text="description"
    item-value="description"
    @change="changeListener"
    :error-messages="errorMessages"
    :outlined="outlined"
  ></v-autocomplete>
</template>

<script>
import { ALL_CHARGE_TYPES_SEARCH_QUERY } from "../../../constants/graphql";

export default {
  name: "ChargeTypesListSelect",

  props: {
    customLabel: { type: String },
    charge: { type: String },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      chargeTypes: {},
      chargeTypesList: [],
      selectedCharge: this.value,
    };
  },

  methods: {
    changeListener(data) {
      if (typeof data == "string") {
        const selected = this.chargeTypesList.find(
          (charge) => charge.description == data
        );
        if (selected) {
          this.$emit("onSelect", selected);
        }
        this.$emit("input", data);
      }
    },
  },

  computed: {
    label() {
      return this.customLabel ? this.customLabel : "Charge Type";
    },
  },

  watch: {
    value(newVal) {
      this.selectedCharge = newVal;
    },
    charge(data) {
      this.selectedCharge = data;
    },
  },

  apollo: {
    chargeTypes: {
      query: ALL_CHARGE_TYPES_SEARCH_QUERY,
      variables() {
        return {};
      },
      result({ data, loader, networkStatus }) {
        this.chargeTypesList = data.chargeTypes.edges.map((node) => {
          return { description: node.node.description, id: node.node.id };
        });
        if (this.value) {
          const selected = this.chargeTypesList.find(
            (charge) => charge.description == this.value
          );
          if (selected) {
            this.$emit("onSelect", selected);
          }
        }
      },
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/ChargeTypesListSelect.vue